var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4263 11.6556C21.4621 11.3026 21.4805 10.9445 21.4805 10.582C21.4805 4.78304 16.7795 0.0820312 10.9805 0.0820312C5.18132 0.0820312 0.480469 4.78288 0.480469 10.582C0.480469 16.3812 5.18132 21.082 10.9805 21.082C11.6593 21.082 12.3231 21.0176 12.9661 20.8945C17.4724 20.0321 20.9557 16.2892 21.4263 11.6556Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2305 11.7687V15.6505H13.9803V12.028C13.9803 11.1187 13.6548 10.4981 12.84 10.4981C12.2184 10.4981 11.8478 10.916 11.685 11.3214C11.6262 11.4663 11.6105 11.6678 11.6105 11.8694V15.6505H9.35927C9.35927 15.6505 9.38972 9.5164 9.35927 8.88115H11.6105V9.8398L11.5958 9.86185H11.6105V9.8398C11.9097 9.3778 12.4431 8.72155 13.6391 8.72155C15.1196 8.72155 16.2305 9.68965 16.2305 11.7687ZM7.00412 5.6167C6.23447 5.6167 5.73047 6.1228 5.73047 6.7864C5.73047 7.4374 6.21977 7.95715 6.97472 7.95715H6.98942C7.77482 7.95715 8.26307 7.43635 8.26307 6.7864C8.24837 6.1228 7.77482 5.6167 7.00412 5.6167ZM5.86382 15.6505H8.11502V8.88115H5.86382V15.6505Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.f832b10358e86158fa44d111b4dbb613.svg";
export { ForwardRef as ReactComponent };